import * as React from "react";
import styled, { css } from "styled-components";

const Item = styled.li`
  flex: 1;
`;

export const TabLink = styled.a<IStyleProps>`
  display: block;
  padding: 0.7rem ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  transition: all 0.2s;

  ${(props) =>
    props.selected &&
    css`
      border-radius: ${({ theme }) => theme.radii[3]};
      background-color: ${({ theme }) => theme.colors.secondaryTwo};
      color: ${({ theme }) => theme.colors.primaryTwo};
    `}
`;

interface IStyleProps {
  selected: boolean;
}

interface IProps {
  index: number;
  label: React.ReactNode;
  link: string;
  onClick: (index: number) => void;
}

type Props = IStyleProps & IProps;

const Tab: React.FC<Props> = ({ index, label, link, onClick, selected }) => {
  const handleOnClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onClick(index);
  };

  return (
    <Item>
      <TabLink href={`#${link}`} onClick={handleOnClick} selected={selected}>
        {label}
      </TabLink>
    </Item>
  );
};

export default Tab;
